// extracted by mini-css-extract-plugin
module.exports = {"root":"CardForm_root__2gq1U","body":"CardForm_body__2npIQ","title":"CardForm_title__2JSll","text":"CardForm_text__2pEbe","buttons":"CardForm_buttons__3EB2i"};